// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"66ab56eb","786":"f6a6b8a6","957":"00b8617d"}[chunkId] + ".chunk.js";
};